// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/maisy-light-background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-right {
  align-items: flex-end !important;
  margin-right: 0;
}
.objection-content-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  justify-content: center;
  gap: 4px; /* Even less space between image and buttons */
  margin-top: 8px;
}

.character-image-left {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.character-image-large {
  width: 270px;
  height: 570px;
  object-fit: contain;
  border-radius: 24px;
  box-shadow: none;
  margin-right: 16px; /* Move image more to the right */
  margin-top: -24px; /* Move image slightly up */
}
/* Background */
.app-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  padding: 0;

}

.phone-mockup {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 30px;
  width: 400px;
  max-width: 100vw;
  height: 750px;
  max-height: 100vh;
  padding: 36px 28px 0 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  gap: 1.2rem;
}

.phone-mockup.light-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.phone-mockup.default-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.logo-container {
  text-align: center;
  margin-bottom: 8px;
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 10px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.logo-subtitle {
  font-size: 18px;
  color: var(--text-gray);
  letter-spacing: 1px;
  font-weight: bold;
}


.character-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.objection-container {
  background: rgba(255,255,255,0.95);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
  padding: 20px;
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.objection-left {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.character-image {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.objection-right {
  width: 100%;
}



.objection-buttons-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 220px;
  align-items: stretch;
  margin-bottom: 10px;
  justify-content: flex-start;
  margin-left: -74px; /* Move button container a bit left */
}

.call-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
}

.speaking-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  font-size: 14px;
  color: var(--call-green);
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background: var(--call-green);
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

.objection-btn {
  width: 100%;
  min-width: 180px;
  max-width: 260px;
  padding: 16px 0;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin: 0 auto;
  display: block;
}

.objection-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.objection-btn.qna {
  background: #4ec16e;
  color: #fff;
}

.objection-btn.shadow {
  background: #f04d4d;
  color: #fff;
}

.objection-btn.roleplay-so {
  background: #ffb800;
  color: #fff;
}

.objection-btn.roleplay-merchant {
  background: #1eb6c1;
  color: #fff;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.3); opacity: 0.6; }
  100% { transform: scale(1); opacity: 1; }
}

/* Mobile Responsiveness */
@media (max-width: 550px) {
  .app-container {
    padding: 0;
    height: 100vh;
    width: 100vw;
    min-height: 100vh;
    min-width: 100vw;
    box-sizing: border-box;
  }
  .phone-mockup {
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh !important;
    max-height: 100vh !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    border-radius: 0 !important;
    padding: 18px 2vw 0 2vw;
    box-shadow: none;
    box-sizing: border-box;
    justify-content: flex-start;
    gap: 0.5rem;
    align-items: center;
  }
  .logo {
    width: 80px;
    margin-bottom: 4px;
  }
  .logo-subtitle {
    font-size: 14px !important;
  }
  .objection-content-row {
    flex-direction: row;
    align-items: flex-start;
    gap: 0;
    margin-top: 0;
    width: 100%;
    justify-content: center;
    padding: 0;
  }
  .character-image-large {
    width: 70px;
    height: 90px;
    margin: 0 10px 0 0;
    display: block;
    float: left;
    align-self: flex-start;
  }
  .objection-buttons-col {
    min-width: 0;
    width: 70vw;
    max-width: 260px;
    gap: 8px;
    align-items: flex-end;
    margin: 0 !important;
    justify-content: flex-start;
    float: right;
  }
  .objection-btn {
    min-width: 120px;
    max-width: 220px;
    width: 90%;
    padding: 10px 0;
    font-size: 14px;
    border-radius: 10px;
    margin: 0 0 8px auto;
    text-align: right;
    display: block;
  }
  .speaking-indicator {
    font-size: 13px !important;
    margin-top: 8px;
  }
}

@media (max-width: 400px) {
  .phone-mockup {
    padding: 4px 0 0 0;
  }
  .logo {
    width: 50px;
  }
  .logo-subtitle {
    font-size: 11px !important;
  }
  .character-image-large {
    width: 55px;
    height: 70px;
  }
  .objection-btn {
    font-size: 10px;
    padding: 6px 0;
    border-radius: 8px;
  }
}

/* Ultra small devices (iPhone SE, Android small, etc) */
@media (max-width: 350px) {
  .phone-mockup {
    padding: 2px 0 0 0;
    gap: 0.2rem;
  }
  .logo {
    width: 38px;
  }
  .logo-subtitle {
    font-size: 9px !important;
  }
  .character-image-large {
    width: 38px;
    height: 48px;
  }
  .objection-btn {
    font-size: 8px;
    padding: 4px 0;
    border-radius: 6px;
  }
}

@media (max-width: 400px) {
  .phone-mockup {
    padding: 6px 0 0 0;
  }
  .logo {
    width: 60px;
  }
  .logo-subtitle {
    font-size: 13px !important;
  }
  .character-image-large {
    width: 70px;
    height: 90px;
  }
  .objection-btn {
    font-size: 12px;
    padding: 8px 0;
    border-radius: 10px;
  }
}

@media (max-width: 435px) and (min-width: 400px) and (max-height: 935px) and (min-height: 900px) {
  .app-container {
    padding: 0;
    height: 100vh;
    width: 100vw;
    min-height: 100vh;
    min-width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .logo-container {
    margin-top: 24px;
    margin-bottom: 0;
    text-align: center;
  }
  .logo {
    width: 90px;
    margin-bottom: 0;
  }
  .logo-subtitle {
    font-size: 18px;
    color: #b0bec5;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .objection-content-row {
    
    width: 100%;
    margin-top: 140px;
    margin-left: -270px;
    gap: 0px;
    padding: 0;
  }
  .character-image-large {
    width: 370px;
    height: 570px;
    border-radius: 24px;
    box-shadow: none;
    margin-left: 00px;
    margin-right: -100px; /* Move image more to the right */
    margin-top: -24px; 
    /* Move image slightly up */
  }
  .objection-buttons-col {
    min-width: 0;
    width: 300px;
    max-width: 300px;
    gap: 10px;
    float: right;
  }
  .objection-btn {
    min-width: 240px;
    max-width: 500px;
    width: 100%;
    padding: 16px 0;
    font-size: 16px;
    border-radius: 16px;
    margin: 0 0 12px auto;
    text-align: center;
    display: block;
    font-weight: 600;
  }
}

@media (max-width: 550px) and (min-width: 300px) and (max-height: 898px) and (min-height: 600px) {
  .app-container {
    padding: 0;
    height: 100vh;
    width: 100vw;
    min-height: 100vh;
    min-width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .logo-container {
    margin-top: 24px;
    margin-bottom: 0;
    text-align: center;
  }
  .logo {
    width: 90px;
    margin-bottom: 0;
  }
  .logo-subtitle {
    font-size: 18px;
    color: #b0bec5;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .objection-content-row {
    
    width: 100%;
    margin-top: 70px;
    margin-left: -240px;
    gap: 20px;
    padding: 0;
  }
  .character-image-large {
    width: 340px;
    height: 570px;
    border-radius: 24px;
    box-shadow: none;
    margin-left: 00px;
    margin-right: -100px; /* Move image more to the right */
    margin-top: -24px; 
    /* Move image slightly up */
  }
  .objection-buttons-col {
    min-width: 0;
    width: 280px;
    max-width: 300px;
    gap: 10px;
    float: right;
  }
  .objection-btn {
    min-width: 210px;
    max-width: 500px;
    width: 100%;
    padding: 16px 0;
    font-size: 16px;
    border-radius: 16px;
    margin: 0 0 12px auto;
    text-align: center;
    display: block;
    font-weight: 600;
  }
}

@media (max-width: 430px) and (min-width: 300px) and (max-height: 770px) and (min-height: 600px) {
  .app-container {
    padding: 0;
    height: 100vh;
    width: 100vw;
    min-height: 100vh;
    min-width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .logo-container {
    margin-top: 20px;
    margin-bottom: 0;
    text-align: center;
  }
  .logo {
    width: 85px;
    margin-bottom: 0;
  }
  .logo-subtitle {
    font-size: 16px;
    color: #b0bec5;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .objection-content-row {
    width: 100%;
    margin-top: 60px;
    margin-left: -220px;
    gap: 16px;
    padding: 0;
  }
  .character-image-large {
    width: 320px;
    height: 540px;
    border-radius: 20px;
    box-shadow: none;
    margin-left: 0;
    margin-right: -80px;
    margin-top: -20px;
  }
  .objection-buttons-col {
    min-width: 0;
    width: 260px;
    max-width: 280px;
    gap: 8px;
    float: right;
  }
  .objection-btn {
    min-width: 200px;
    max-width: 480px;
    width: 100%;
    padding: 14px 0;
    font-size: 15px;
    border-radius: 14px;
    margin: 0 0 10px auto;
    text-align: center;
    display: block;
    font-weight: 600;
  }
}

@media (max-width: 375px) and (min-width: 220px) and (max-height: 935px) and (min-height: 900px) {
  .app-container {
    padding: 0;
    height: 100vh;
    width: 100vw;
    min-height: 100vh;
    min-width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .logo-container {
    margin-top: 20px;
    margin-bottom: 0;
    text-align: center;
  }
  .logo {
    width: 75px;
    margin-bottom: 0;
  }
  .logo-subtitle {
    font-size: 16px;
    color: #b0bec5;
    margin-bottom: 0;
    margin-top: 0;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .objection-content-row {
    width: 100%;
    margin-top: 120px;
    margin-left: -200px;
    gap: 0px;
    padding: 0;
  }
  .character-image-large {
    width: 300px;
    height: 480px;
    border-radius: 20px;
    box-shadow: none;
    margin-left: 0;
    margin-right: -80px;
    margin-top: -20px;
  }
  .objection-buttons-col {
    min-width: 0;
    width: 240px;
    max-width: 240px;
    gap: 8px;
    float: right;
  }
  .objection-btn {
    min-width: 200px;
    max-width: 400px;
    width: 100%;
    padding: 14px 0;
    font-size: 14px;
    border-radius: 14px;
    margin: 0 0 10px auto;
    text-align: center;
    display: block;
    font-weight: 600;
  }
}

.logo-lang-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
  position: relative;
}

.logo-lang-row .logo-container {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0;
  margin-left: 24px; /* Move logo a bit right */
}

.language-dropdown-container.objection-language-dropdown-container {
  margin-bottom: 0;
  margin-left: auto;
  flex: 0 0 auto;
  margin-top: 12px; /* Move dropdown a bit down */
}

.objection-top-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  margin-left: auto;
  flex: 0 0 auto;
}

.realtime-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #222;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.realtime-toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.realtime-slider {
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: #d5dbe0;
  position: relative;
  transition: background 0.2s ease;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.16);
}

.realtime-slider::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.24);
  transition: transform 0.2s ease;
}

.realtime-toggle input:checked + .realtime-slider {
  background: #1eb6c1;
}

.realtime-toggle input:checked + .realtime-slider::after {
  transform: translateX(16px);
}

.realtime-toggle input:disabled + .realtime-slider,
.realtime-toggle input:disabled ~ .realtime-label {
  opacity: 0.65;
  cursor: not-allowed;
}

.realtime-label {
  line-height: 1;
}

@media (max-width: 700px) {
  .logo-lang-row {
    margin-bottom: 4px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .logo-lang-row .logo-container {
    margin-bottom: 0;
    align-items: center;
    margin-left: 12px;
  }
  .language-dropdown-container.objection-language-dropdown-container {
    margin-bottom: 0;
    margin-left: 0;
    margin-top: 8px;
    align-self: flex-end;
  }
  .objection-top-controls {
    align-items: flex-end;
    margin-left: 0;
    margin-top: 8px;
  }
}

.language-dropdown.objection-language-dropdown {
  background: #f7f7f7;
  color: #222;
  font-weight: 600;
  font-size: 16px;
  border: 1.5px solid #e0e0e0;
  outline: none;
  cursor: pointer;
  padding: 8px 28px 8px 8px;
  border-radius: 8px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: border 0.2s, box-shadow 0.2s;
  min-width: 90px;
  width: auto;
}

.language-dropdown-arrow.objection-language-dropdown-arrow {
  position: absolute;
  right: 12px;
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  height: 100%;
}

.language-dropdown-arrow.objection-language-dropdown-arrow svg path {
  stroke: #888;
}

@media (max-width: 700px) {
  .language-dropdown-container.objection-language-dropdown-container {
    margin-bottom: 6px;
  }
  .language-dropdown.objection-language-dropdown {
    font-size: 14px;
    padding: 6px 22px 6px 6px;
    min-width: 60px;
  }
  .language-dropdown-arrow.objection-language-dropdown-arrow {
    right: 8px;
  }
}

.objection-language-dropdown option {
  color: #222;
  background: #fff;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/ObjectionHandling.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,QAAQ,EAAE,8CAA8C;EACxD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAE,iCAAiC;EACrD,iBAAiB,EAAE,2BAA2B;AAChD;AACA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,UAAU;;AAEZ;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sCAAsC;EACtC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,MAAM,qBAAqB,EAAE,YAAY,EAAE;EAC3C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,QAAQ;IACR,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB,EAAE,iCAAiC;IACvD,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB,EAAE,iCAAiC;IACvD,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB,EAAE,0BAA0B;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sCAAsC;EACtC,wCAAwC;EACxC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".align-right {\n  align-items: flex-end !important;\n  margin-right: 0;\n}\n.objection-content-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  justify-content: center;\n  gap: 4px; /* Even less space between image and buttons */\n  margin-top: 8px;\n}\n\n.character-image-left {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.character-image-large {\n  width: 270px;\n  height: 570px;\n  object-fit: contain;\n  border-radius: 24px;\n  box-shadow: none;\n  margin-right: 16px; /* Move image more to the right */\n  margin-top: -24px; /* Move image slightly up */\n}\n/* Background */\n.app-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  padding: 0;\n\n}\n\n.phone-mockup {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 30px;\n  width: 400px;\n  max-width: 100vw;\n  height: 750px;\n  max-height: 100vh;\n  padding: 36px 28px 0 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  gap: 1.2rem;\n}\n\n.phone-mockup.light-bg {\n  background-image: url('./assets/maisy-light-background.png');\n}\n\n.phone-mockup.default-bg {\n  background-image: url('./assets/background.png');\n}\n\n.logo-container {\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.logo {\n  width: 120px;\n  height: auto;\n  margin-bottom: 10px;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\n}\n\n.logo-subtitle {\n  font-size: 18px;\n  color: var(--text-gray);\n  letter-spacing: 1px;\n  font-weight: bold;\n}\n\n\n.character-image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.objection-container {\n  background: rgba(255,255,255,0.95);\n  border-radius: 20px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.08);\n  padding: 20px;\n  width: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.objection-left {\n  margin-bottom: 20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.character-image {\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  object-fit: cover;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.objection-right {\n  width: 100%;\n}\n\n\n\n.objection-buttons-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 220px;\n  align-items: stretch;\n  margin-bottom: 10px;\n  justify-content: flex-start;\n  margin-left: -74px; /* Move button container a bit left */\n}\n\n.call-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.speaking-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  font-size: 14px;\n  color: var(--call-green);\n}\n\n.pulse-dot {\n  width: 8px;\n  height: 8px;\n  background: var(--call-green);\n  border-radius: 50%;\n  animation: pulse 1.5s infinite;\n}\n\n.objection-btn {\n  width: 100%;\n  min-width: 180px;\n  max-width: 260px;\n  padding: 16px 0;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  margin: 0 auto;\n  display: block;\n}\n\n.objection-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.objection-btn.qna {\n  background: #4ec16e;\n  color: #fff;\n}\n\n.objection-btn.shadow {\n  background: #f04d4d;\n  color: #fff;\n}\n\n.objection-btn.roleplay-so {\n  background: #ffb800;\n  color: #fff;\n}\n\n.objection-btn.roleplay-merchant {\n  background: #1eb6c1;\n  color: #fff;\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.3); opacity: 0.6; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 550px) {\n  .app-container {\n    padding: 0;\n    height: 100vh;\n    width: 100vw;\n    min-height: 100vh;\n    min-width: 100vw;\n    box-sizing: border-box;\n  }\n  .phone-mockup {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    height: 100vh !important;\n    max-height: 100vh !important;\n    min-width: 100vw !important;\n    min-height: 100vh !important;\n    border-radius: 0 !important;\n    padding: 18px 2vw 0 2vw;\n    box-shadow: none;\n    box-sizing: border-box;\n    justify-content: flex-start;\n    gap: 0.5rem;\n    align-items: center;\n  }\n  .logo {\n    width: 80px;\n    margin-bottom: 4px;\n  }\n  .logo-subtitle {\n    font-size: 14px !important;\n  }\n  .objection-content-row {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 0;\n    margin-top: 0;\n    width: 100%;\n    justify-content: center;\n    padding: 0;\n  }\n  .character-image-large {\n    width: 70px;\n    height: 90px;\n    margin: 0 10px 0 0;\n    display: block;\n    float: left;\n    align-self: flex-start;\n  }\n  .objection-buttons-col {\n    min-width: 0;\n    width: 70vw;\n    max-width: 260px;\n    gap: 8px;\n    align-items: flex-end;\n    margin: 0 !important;\n    justify-content: flex-start;\n    float: right;\n  }\n  .objection-btn {\n    min-width: 120px;\n    max-width: 220px;\n    width: 90%;\n    padding: 10px 0;\n    font-size: 14px;\n    border-radius: 10px;\n    margin: 0 0 8px auto;\n    text-align: right;\n    display: block;\n  }\n  .speaking-indicator {\n    font-size: 13px !important;\n    margin-top: 8px;\n  }\n}\n\n@media (max-width: 400px) {\n  .phone-mockup {\n    padding: 4px 0 0 0;\n  }\n  .logo {\n    width: 50px;\n  }\n  .logo-subtitle {\n    font-size: 11px !important;\n  }\n  .character-image-large {\n    width: 55px;\n    height: 70px;\n  }\n  .objection-btn {\n    font-size: 10px;\n    padding: 6px 0;\n    border-radius: 8px;\n  }\n}\n\n/* Ultra small devices (iPhone SE, Android small, etc) */\n@media (max-width: 350px) {\n  .phone-mockup {\n    padding: 2px 0 0 0;\n    gap: 0.2rem;\n  }\n  .logo {\n    width: 38px;\n  }\n  .logo-subtitle {\n    font-size: 9px !important;\n  }\n  .character-image-large {\n    width: 38px;\n    height: 48px;\n  }\n  .objection-btn {\n    font-size: 8px;\n    padding: 4px 0;\n    border-radius: 6px;\n  }\n}\n\n@media (max-width: 400px) {\n  .phone-mockup {\n    padding: 6px 0 0 0;\n  }\n  .logo {\n    width: 60px;\n  }\n  .logo-subtitle {\n    font-size: 13px !important;\n  }\n  .character-image-large {\n    width: 70px;\n    height: 90px;\n  }\n  .objection-btn {\n    font-size: 12px;\n    padding: 8px 0;\n    border-radius: 10px;\n  }\n}\n\n@media (max-width: 435px) and (min-width: 400px) and (max-height: 935px) and (min-height: 900px) {\n  .app-container {\n    padding: 0;\n    height: 100vh;\n    width: 100vw;\n    min-height: 100vh;\n    min-width: 100vw;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .logo-container {\n    margin-top: 24px;\n    margin-bottom: 0;\n    text-align: center;\n  }\n  .logo {\n    width: 90px;\n    margin-bottom: 0;\n  }\n  .logo-subtitle {\n    font-size: 18px;\n    color: #b0bec5;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-weight: 600;\n    letter-spacing: 1px;\n  }\n  .objection-content-row {\n    \n    width: 100%;\n    margin-top: 140px;\n    margin-left: -270px;\n    gap: 0px;\n    padding: 0;\n  }\n  .character-image-large {\n    width: 370px;\n    height: 570px;\n    border-radius: 24px;\n    box-shadow: none;\n    margin-left: 00px;\n    margin-right: -100px; /* Move image more to the right */\n    margin-top: -24px; \n    /* Move image slightly up */\n  }\n  .objection-buttons-col {\n    min-width: 0;\n    width: 300px;\n    max-width: 300px;\n    gap: 10px;\n    float: right;\n  }\n  .objection-btn {\n    min-width: 240px;\n    max-width: 500px;\n    width: 100%;\n    padding: 16px 0;\n    font-size: 16px;\n    border-radius: 16px;\n    margin: 0 0 12px auto;\n    text-align: center;\n    display: block;\n    font-weight: 600;\n  }\n}\n\n@media (max-width: 550px) and (min-width: 300px) and (max-height: 898px) and (min-height: 600px) {\n  .app-container {\n    padding: 0;\n    height: 100vh;\n    width: 100vw;\n    min-height: 100vh;\n    min-width: 100vw;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .logo-container {\n    margin-top: 24px;\n    margin-bottom: 0;\n    text-align: center;\n  }\n  .logo {\n    width: 90px;\n    margin-bottom: 0;\n  }\n  .logo-subtitle {\n    font-size: 18px;\n    color: #b0bec5;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-weight: 600;\n    letter-spacing: 1px;\n  }\n  .objection-content-row {\n    \n    width: 100%;\n    margin-top: 70px;\n    margin-left: -240px;\n    gap: 20px;\n    padding: 0;\n  }\n  .character-image-large {\n    width: 340px;\n    height: 570px;\n    border-radius: 24px;\n    box-shadow: none;\n    margin-left: 00px;\n    margin-right: -100px; /* Move image more to the right */\n    margin-top: -24px; \n    /* Move image slightly up */\n  }\n  .objection-buttons-col {\n    min-width: 0;\n    width: 280px;\n    max-width: 300px;\n    gap: 10px;\n    float: right;\n  }\n  .objection-btn {\n    min-width: 210px;\n    max-width: 500px;\n    width: 100%;\n    padding: 16px 0;\n    font-size: 16px;\n    border-radius: 16px;\n    margin: 0 0 12px auto;\n    text-align: center;\n    display: block;\n    font-weight: 600;\n  }\n}\n\n@media (max-width: 430px) and (min-width: 300px) and (max-height: 770px) and (min-height: 600px) {\n  .app-container {\n    padding: 0;\n    height: 100vh;\n    width: 100vw;\n    min-height: 100vh;\n    min-width: 100vw;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .logo-container {\n    margin-top: 20px;\n    margin-bottom: 0;\n    text-align: center;\n  }\n  .logo {\n    width: 85px;\n    margin-bottom: 0;\n  }\n  .logo-subtitle {\n    font-size: 16px;\n    color: #b0bec5;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-weight: 600;\n    letter-spacing: 1px;\n  }\n  .objection-content-row {\n    width: 100%;\n    margin-top: 60px;\n    margin-left: -220px;\n    gap: 16px;\n    padding: 0;\n  }\n  .character-image-large {\n    width: 320px;\n    height: 540px;\n    border-radius: 20px;\n    box-shadow: none;\n    margin-left: 0;\n    margin-right: -80px;\n    margin-top: -20px;\n  }\n  .objection-buttons-col {\n    min-width: 0;\n    width: 260px;\n    max-width: 280px;\n    gap: 8px;\n    float: right;\n  }\n  .objection-btn {\n    min-width: 200px;\n    max-width: 480px;\n    width: 100%;\n    padding: 14px 0;\n    font-size: 15px;\n    border-radius: 14px;\n    margin: 0 0 10px auto;\n    text-align: center;\n    display: block;\n    font-weight: 600;\n  }\n}\n\n@media (max-width: 375px) and (min-width: 220px) and (max-height: 935px) and (min-height: 900px) {\n  .app-container {\n    padding: 0;\n    height: 100vh;\n    width: 100vw;\n    min-height: 100vh;\n    min-width: 100vw;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .logo-container {\n    margin-top: 20px;\n    margin-bottom: 0;\n    text-align: center;\n  }\n  .logo {\n    width: 75px;\n    margin-bottom: 0;\n  }\n  .logo-subtitle {\n    font-size: 16px;\n    color: #b0bec5;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-weight: 600;\n    letter-spacing: 1px;\n  }\n  .objection-content-row {\n    width: 100%;\n    margin-top: 120px;\n    margin-left: -200px;\n    gap: 0px;\n    padding: 0;\n  }\n  .character-image-large {\n    width: 300px;\n    height: 480px;\n    border-radius: 20px;\n    box-shadow: none;\n    margin-left: 0;\n    margin-right: -80px;\n    margin-top: -20px;\n  }\n  .objection-buttons-col {\n    min-width: 0;\n    width: 240px;\n    max-width: 240px;\n    gap: 8px;\n    float: right;\n  }\n  .objection-btn {\n    min-width: 200px;\n    max-width: 400px;\n    width: 100%;\n    padding: 14px 0;\n    font-size: 14px;\n    border-radius: 14px;\n    margin: 0 0 10px auto;\n    text-align: center;\n    display: block;\n    font-weight: 600;\n  }\n}\n\n.logo-lang-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.logo-lang-row .logo-container {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 0;\n  margin-left: 24px; /* Move logo a bit right */\n}\n\n.language-dropdown-container.objection-language-dropdown-container {\n  margin-bottom: 0;\n  margin-left: auto;\n  flex: 0 0 auto;\n  margin-top: 12px; /* Move dropdown a bit down */\n}\n\n.objection-top-controls {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  margin-left: auto;\n  flex: 0 0 auto;\n}\n\n.realtime-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #222;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  user-select: none;\n}\n\n.realtime-toggle input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.realtime-slider {\n  width: 38px;\n  height: 22px;\n  border-radius: 999px;\n  background: #d5dbe0;\n  position: relative;\n  transition: background 0.2s ease;\n  box-shadow: inset 0 1px 3px rgba(0,0,0,0.16);\n}\n\n.realtime-slider::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.24);\n  transition: transform 0.2s ease;\n}\n\n.realtime-toggle input:checked + .realtime-slider {\n  background: #1eb6c1;\n}\n\n.realtime-toggle input:checked + .realtime-slider::after {\n  transform: translateX(16px);\n}\n\n.realtime-toggle input:disabled + .realtime-slider,\n.realtime-toggle input:disabled ~ .realtime-label {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.realtime-label {\n  line-height: 1;\n}\n\n@media (max-width: 700px) {\n  .logo-lang-row {\n    margin-bottom: 4px;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n  }\n  .logo-lang-row .logo-container {\n    margin-bottom: 0;\n    align-items: center;\n    margin-left: 12px;\n  }\n  .language-dropdown-container.objection-language-dropdown-container {\n    margin-bottom: 0;\n    margin-left: 0;\n    margin-top: 8px;\n    align-self: flex-end;\n  }\n  .objection-top-controls {\n    align-items: flex-end;\n    margin-left: 0;\n    margin-top: 8px;\n  }\n}\n\n.language-dropdown.objection-language-dropdown {\n  background: #f7f7f7;\n  color: #222;\n  font-weight: 600;\n  font-size: 16px;\n  border: 1.5px solid #e0e0e0;\n  outline: none;\n  cursor: pointer;\n  padding: 8px 28px 8px 8px;\n  border-radius: 8px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n  transition: border 0.2s, box-shadow 0.2s;\n  min-width: 90px;\n  width: auto;\n}\n\n.language-dropdown-arrow.objection-language-dropdown-arrow {\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.language-dropdown-arrow.objection-language-dropdown-arrow svg path {\n  stroke: #888;\n}\n\n@media (max-width: 700px) {\n  .language-dropdown-container.objection-language-dropdown-container {\n    margin-bottom: 6px;\n  }\n  .language-dropdown.objection-language-dropdown {\n    font-size: 14px;\n    padding: 6px 22px 6px 6px;\n    min-width: 60px;\n  }\n  .language-dropdown-arrow.objection-language-dropdown-arrow {\n    right: 8px;\n  }\n}\n\n.objection-language-dropdown option {\n  color: #222;\n  background: #fff;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
